import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Divider } from "../../elements/Divider";
export var Component = function Component(_ref) {
  var children = _ref.children;
  return React.createElement(Fragment, null, React.createElement(Divider, {
    size: "large"
  }), children, React.createElement(Divider, {
    size: "large"
  }));
};
Component.displayName = 'VerticalGutters';
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired
} : {};